import { Link, Message } from "basis";
import { getRegional } from "library/getRegional";
import { ReactNode } from "react";

const auHelpLink = "https://latitudefs.zendesk.com/hc/en-au/";
const nzHelpLink = "https://gemfinance.zendesk.com/hc/en-nz/";

interface Props {
  errorEnum: string;
}

export function LinkErrorMessage({ errorEnum }: Props): ReactNode {
  const isNz = getRegional("code") === "NZ";
  const url = isNz ? nzHelpLink : auHelpLink;

  switch (errorEnum) {
    case "ACCOUNT_COULD_NOT_BE_LINKED":
    case "ACCOUNT_NOT_MATCHED":
    case "ACCOUNT_STATUS_INELIGIBLE":
    case "NO_MOBILE_NUMBER":
    case "PHONE_NUMBER_COUNTRY_CODE_NOT_SUPPORTED":
    case "PHONE_NUMBER_COUNTRY_CODE_NULL":
    case "PRODUCT_LINK_INELIGIBLE":
    case "PROFILE_LINK_ATTEMPTS_LIMIT_EXCEEDED": {
      return (
        <Message severity="blocking" bg="secondary.pink.t30">
          Sorry, we've been unable to link your account. The{" "}
          <Link href={url} newTab>
            Help section
          </Link>{" "}
          of the Latitude website provides a range of useful information, along
          with ways to contact us.
        </Message>
      );
    }
    case "ACCOUNT_LINK_ATTEMPTS_LIMIT_EXCEEDED":
    case "SOUTHBOUND_ERROR":
    case "CARD_LINK_ATTEMPTS_LIMIT_EXCEEDED": {
      return (
        <Message severity="blocking" bg="secondary.pink.t30">
          Oops, something went wrong. Please try again in 24 hours or contact us
          via the{" "}
          <Link href={url} newTab>
            Help section
          </Link>{" "}
          of the Latitude website.
        </Message>
      );
    }
    case "ADDITIONAL_INFORMATION_REQUIRED": {
      return (
        <Message severity="blocking" bg="secondary.pink.t30">
          Please provide your first name or contact us via the{" "}
          <Link href={url} newTab>
            Help section
          </Link>{" "}
          of the Latitude website.
        </Message>
      );
    }
    default: {
      return (
        <Message severity="blocking" bg="secondary.pink.t30">
          "There has been an unexpected error."
        </Message>
      );
    }
  }
}
